<template>
  <div class="filter-container sla-filters">
    <reports-filters-sla
      v-if="showSlaFilter"
      @sla-filter-selection="handleSlaFilterSelection"
    />
    <reports-filters-inboxes
      v-if="showInboxFilter"
      @inbox-filter-selection="handleInboxFilterSelection"
    />
    <reports-filters-agents
      v-if="showAgentsFilter"
      @agents-filter-selection="handleAgentsFilterSelection"
    />
    <reports-filters-date-range @on-range-change="onDateRangeChange" />
    <woot-date-range-picker
      v-if="isDateRangeSelected"
      show-range
      class="no-margin auto-width"
      :value="customDateRange"
      :selected-option="selectedOption"
      :confirm-text="$t('REPORT.CUSTOM_DATE_RANGE.CONFIRM')"
      :placeholder="$t('REPORT.CUSTOM_DATE_RANGE.PLACEHOLDER')"
      @change="onCustomDateRangeChange"
    />
  </div>
</template>

<script>
import subDays from 'date-fns/subDays';
import { DATE_RANGE_OPTIONS, GROUP_BY_OPTIONS } from '../../constants';
import {
  getUnixStartOfDay,
  getUnixEndOfDay,
  getDateTime,
} from 'shared/helpers/DateHelper';
import { getTodayRange } from 'shared/helpers/DateHelper';
import WootDateRangePicker from 'dashboard/components/ui/DateRangePicker.vue';
import ReportsFiltersDateRange from '../Filters/DateRange.vue';
import ReportsFiltersAgents from '../Filters/Agents.vue';
import ReportsFiltersInboxes from '../Filters/Inboxes.vue';
import ReportsFiltersSla from '../Filters/Sla.vue';

export default {
  components: {
    WootDateRangePicker,
    ReportsFiltersDateRange,
    ReportsFiltersAgents,
    ReportsFiltersInboxes,
    ReportsFiltersSla,
  },
  props: {
    filterItemsList: {
      type: Array,
      default: () => [],
    },
    showAgentsFilter: {
      type: Boolean,
      default: true,
    },
    showInboxFilter: {
      type: Boolean,
      default: true,
    },
    showSlaFilter: {
      type: Boolean,
      default: true,
    },
    selectedOption: {
      type: Object,
      default: () => GROUP_BY_OPTIONS.DAY,
    },
  },
  data() {
    return {
      selectedDateRange: DATE_RANGE_OPTIONS.TODAY,
      selectedGroupByFilter: this.selectedOption,
      customDateRange: [new Date(), new Date()],
      selectedAgents: [],
      selectedSlas: [],
      selectedInbox: null,
    };
  },
  computed: {
    to() {
      if (this.isDateRangeSelected) {
        return getDateTime(this.customDateRange[1]);
      }
      if (this.selectedDateRange.id === DATE_RANGE_OPTIONS.TODAY.id) {
        return getTodayRange().to;
      }
      return getUnixEndOfDay(new Date());
    },
    from() {
      if (this.isDateRangeSelected) {
        return getDateTime(this.customDateRange[0]);
      }
      if (this.selectedDateRange.id === DATE_RANGE_OPTIONS.TODAY.id) {
        return getTodayRange().from;
      }
      const { offset } = this.selectedDateRange;
      const fromDate = subDays(new Date(), offset);
      return getUnixStartOfDay(fromDate);
    },
    isDateRangeSelected() {
      return (
        this.selectedDateRange.id === DATE_RANGE_OPTIONS.CUSTOM_DATE_RANGE.id
      );
    },
  },
  mounted() {
    this.emitChange();
  },
  methods: {
    validGroupOptions() {
      return this.selectedDateRange.groupByOptions;
    },
    validGroupBy() {
      if (!this.selectedGroupByFilter) {
        return this.validGroupOptions[0];
      }
      const validIds = this.validGroupOptions.map(opt => opt.id);
      if (validIds.includes(this.selectedGroupByFilter.id)) {
        return this.selectedGroupByFilter;
      }
      return this.validGroupOptions[0];
    },
    onDateRangeChange(selectedRange) {
      this.selectedDateRange = selectedRange;
      this.selectedGroupByFilter = this.validGroupBy;
      this.emitChange();
    },
    onCustomDateRangeChange(value) {
      this.customDateRange = value;
      this.selectedGroupByFilter = this.validGroupBy;
      this.emitChange();
    },
    handleAgentsFilterSelection(selectedAgents) {
      this.selectedAgents = selectedAgents;
      this.emitChange();
    },
    handleSlaFilterSelection(selectedSlas) {
      this.selectedSlas = selectedSlas;
      this.emitChange();
    },
    handleInboxFilterSelection(selectedInbox) {
      this.selectedInbox = selectedInbox;
      this.emitChange();
    },
    emitChange() {
      const { from, to, selectedAgents, selectedInbox, selectedSlas } = this;
      this.$emit('filterChange', {
        from,
        to,
        inbox_id: selectedInbox?.id ?? null,
        sla_policy_ids: selectedSlas.map(item => item.id),
        sla_policy_id: selectedSlas?.[0]?.id ?? null,
        assigned_agent_ids: selectedAgents.map(item => item.id),
        assigned_agent_id: selectedAgents?.[0]?.id ?? null,
      });
    },
    emitFilterChange(params) {
      this.selectedGroupByFilter = params;
      this.emitChange();
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: var(--space-slab);

  margin-bottom: var(--space-normal);
  @media screen and (max-width: 1300px) {
    display: grid;
    grid-template-columns: auto;
  }

  @media screen and (min-width: 1301px) and (max-width: 1800px) {
    display: grid;
    grid-template-columns: auto auto;
  }
}

.sla-filters {
  .auto-width {
    min-width: 270px;
  }
}
</style>
